<template>
    <div class="main-content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card p-4">
                        <h4 class="mb-4"><i class="fas fa-car mr-2"></i> Consulta de Vehículos (ANT)</h4>

                        <div class="row align-items-end mb-4">
                            <div class="col-md-4">
                                <label>Ingrese la Placa:</label>
                                <vs-input v-model="placa" placeholder="Ej: GTJ6783" @keyup.enter="consultarPlaca()" block>
                                    <template #icon><i class='fas fa-search'></i></template>
                                </vs-input>
                            </div>
                            <div class="col-md-2">
                                <vs-button @click="consultarPlaca()" :loading="loading" block>
                                    Consultar
                                </vs-button>
                            </div>
                        </div>

                        <div v-if="vehiculo" class="mt-4">
    <div class="row">
        <div class="col-md-7">
            <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead class="thead-dark">
                        <tr><th colspan="2" class="text-center"><i class="fas fa-id-card"></i> DATOS REGISTRADOS (ANT)</th></tr>
                    </thead>
                    <tbody>
                        <tr><td width="40%"><strong>Placa:</strong></td><td>{{ vehiculo.placa }}</td></tr>
                        <tr><td><strong>Marca:</strong></td><td>{{ vehiculo.marca }}</td></tr>
                        <tr><td><strong>Modelo:</strong></td><td>{{ vehiculo.modelo }}</td></tr>
                        <tr><td><strong>Año:</strong></td><td>{{ vehiculo.anio }}</td></tr>
                        <!--tr><td><strong>Año:</strong></td><td>No Registra</td></tr-->
                        <tr><td><strong>Color:</strong></td><td>{{ vehiculo.color }}</td></tr>
                        <!--tr><td><strong>Color:</strong></td><td>No Registra</td></tr-->
                        <tr><td><strong>Clase:</strong></td><td>{{ vehiculo.clase }}</td></tr>
                        <tr><td><strong>Servicio:</strong></td><td>{{ vehiculo.servicio }}</td></tr>
                        <tr><td><strong>Polarizado:</strong></td><td>{{ vehiculo.polarizado }}</td></tr>
                        <tr><td><strong>Año de Matrícula:</strong></td><td>{{ vehiculo.anio_matricula }}</td></tr>
                        <!--tr><td><strong>Año de Matrícula:</strong></td><td>No Registra</td></tr-->
                        <tr><td><strong>Fecha de Matrícula:</strong></td><td>{{ vehiculo.fecha_matricula }}</td></tr>
                        <!--tr><td><strong>Fecha de Matrícula:</strong></td><td>No Registra</td></tr-->
                        <tr><td><strong>Fecha de Caducidad:</strong></td><td>{{ vehiculo.fecha_caducidad }}</td></tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-md-5">
            <div class="card border-info shadow-sm">
                <div class="card-header bg-info text-white text-center">
                    <strong><i class="fas fa-tags"></i> PRECIOS REFERENCIALES DE MERCADO</strong>
                </div>
                <div class="card-body bg-light">
                    <p class="text-muted text-center small mb-3">Valores calculados dinámicamente en base a cotizaciones activas de PatioTuerca Ecuador.</p>

                    <div class="d-flex justify-content-between align-items-center p-3 mb-2 bg-white rounded border">
                        <span class="text-secondary"><strong>Precio más bajo:</strong></span>
                        <span class="badge badge-warning p-2" style="font-size: 14px;">{{ vehiculo.precio_bajo }}</span>
                    </div>

                    <div class="d-flex justify-content-between align-items-center p-3 mb-2 bg-white rounded border" style="border-left: 5px solid #28a745 !important;">
                        <span class="text-success"><strong>PRECIO IDEAL:</strong></span>
                        <span class="badge badge-success p-2" style="font-size: 16px;">{{ vehiculo.precio_ideal }}</span>
                    </div>

                    <div class="d-flex justify-content-between align-items-center p-3 mb-2 bg-white rounded border">
                        <span class="text-secondary"><strong>Precio más alto:</strong></span>
                        <span class="badge badge-danger p-2" style="font-size: 14px;">{{ vehiculo.precio_alto }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { alertasM } from '../../../util.js';
export default {
    mixins: [alertasM],
    data() {
        return {
            placa: '',
            loading: false,
            vehiculo: null
        }
    },
    methods: {
        consultarPlaca() {
            if (!this.placa) {
                this.notify("Ingrese una placa", "", "top", "center", "fas fa-exclamation-triangle", "warning");
                return;
            }
            this.loading = true;
            this.vehiculo = null;

            axios.get('/vehiculo/consultar', { params: { placa: this.placa } })
                .then(res => {
                    if (res.data.success) {
                        this.vehiculo = res.data.data;
                    } else {
                        this.notify(res.data.message, "", "top", "center", "fas fa-info-circle", "warning");
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.notify("Error al conectar con la ANT o placa no encontrada:"+err, "", "top", "center", "fas fa-times", "danger");
                })
                .finally(() => { this.loading = false; });
        }
    }
}
</script>
